export const comnEnvs = {
    base: `${process.env.REACT_APP_BASE}`,
    base_comn: `${process.env.REACT_APP_BASE_COMN}`,
    locale: {
        ko: "ko-KR",
        en: "en-TZ",
        tz: "sw-TZ",
    },
    url: {
        // external
        ptle: process.env.REACT_APP_URL_PTLE,
        lcme: process.env.REACT_APP_URL_LCME,
        olme: process.env.REACT_APP_URL_OLME,
        cgme: process.env.REACT_APP_URL_CGME,
        efme: process.env.REACT_APP_URL_EFME,
        ecte: process.env.REACT_APP_URL_ECTE,
        clre: process.env.REACT_APP_URL_CLRE,
        pcle: process.env.REACT_APP_URL_PCLE,
        cole: process.env.REACT_APP_URL_COLE,
        clbe: process.env.REACT_APP_URL_CLBE,
        eswe: process.env.REACT_APP_URL_ESWE,
        lfpe: process.env.REACT_APP_URL_LFPE,
        // internal
        ptli: process.env.REACT_APP_URL_PTLI,
        lcmi: process.env.REACT_APP_URL_LCMI,
        olmi: process.env.REACT_APP_URL_OLMI,
        cgmi: process.env.REACT_APP_URL_CGMI,
        efmi: process.env.REACT_APP_URL_EFMI,
        ecti: process.env.REACT_APP_URL_ECTI,
        clri: process.env.REACT_APP_URL_CLRI,
        pcli: process.env.REACT_APP_URL_PCLI,
        coli: process.env.REACT_APP_URL_COLI,
        clbi: process.env.REACT_APP_URL_CLBI,
        rkmi: process.env.REACT_APP_URL_RKMI,
        tdwi: process.env.REACT_APP_URL_TDWI,
        // oga
        ogao: process.env.REACT_APP_URL_OGAO,
        eswo: process.env.REACT_APP_URL_ESWO,
        lfpo: process.env.REACT_APP_URL_LFPO,
    },
    popup: {
        comnCd: "comn:comnCd",
        cityCd: "comn:cityCd",
        unLocCd: "comn:unLocCd",
        cntyCd: "comn:cntyCd",
        dgt3CntyCd: "comn:dgt3CntyCd",
        dgt3NumCntyCd: "comn:dgt3NumCntyCd",
        bnkCd: "comn:bnkCd",
        currCd: "comn:currCd",
        portCd: "comn:portCd",
        portAirptCd: "comn:portAirptCd",
        airptCd: "comn:airptCd",
        coCd: "comn:coCd",
        prcssStatCd: "comn:prcssStatCd",
        orgCd: "comn:orgCd",
        wrhsCd: "comn:wrhsCd",
        carrCd: "comn:carrCd",
        coDclaCd: "comn:coDclaCd",
        orgDeptCd: "comn:orgDeptCd",
        cstmCd: "comn:cstmCd",
        cstmOfcrCd: "comn:cstmOfcrCd",
        cstmOrgzCd: "comn:cstmOrgzCd",
        vhclBodyCd: "comn:vhclBodyCd",
        vhclCtgrCd: "comn:vhclCtgrCd",
        vhclClrCd: "comn:vhclClrCd",
        vhclFlCd: "comn:vhclFlCd",
        vhclMkerCd: "comn:vhclMkerCd",
        vhclImpCntyCd: "comn:vhclImpCntyCd",
        vhclInsrTpCd: "comn:vhclInsrTpCd",
        vhclMdlCd: "comn:vhclMdlCd",
        vhclMdlNoCd: "comn:vhclMdlNoCd",
        vhclHlpnCtgrCd: "comn:vhclHlpnCtgrCd",
        vhclPrplTpCd: "comn:vhclPrplTpCd",
        vhclTrmssnTpCd: "comn:vhclTrmssnTpCd",
        vhclUseCd: "comn:vhclUseCd",
        coCdDtl: "comn:coCdDtl",
        hsCd: "comn:hsCd",
        postCd: "comn:postCd",
        tinNo: "comn:tinNo",
        ucrNo: "comn:ucrNo",
        epcCd: "comn:epcCd",
        apcCd: "comn:apcCd",
        trmnlOptrCd: "comn:trmnlOptrCd",
        tb: "comn:tb",
        indvCdTb: "comn:indvCdTb",
        col: "comn:col",
        indvCdCol: "comn:indvCdCol",
        lbl: "comn:lbl",
        comnCdMstr: "comn:comnCdMstr",
        dclt: "comn:dclt",
        coUsr: "comn:coUsr",
        orgUsr: "comn:orgUsr",
        coBucn: "comn:coBucn",
        orgz: "comn:orgz",
        orgzSub: "comn:orgzSub",
        orgzUsrRgsr: "comn:orgzUsrRgsr",
        hldy: "comn:hldy",
        csldrTin: "comn:csldrTin",
        roleCd: "comn:roleCd",
    },
};
